"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPerm = void 0;
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var getPerm = function (groupType, rowType, perm, disabled) {
    var p = {
        editAllowed: false,
        removeAllowed: false
    };
    switch (groupType) {
        case 'CustomerCategoryUserGroup':
            if (disabled && disabled.customerCategoryGroup) {
                p.editAllowed =
                    (perm & acl.CUSTOMER_ADMIN_GRANT) !== 0 &&
                        !disabled.customerCategoryGroup.edit;
                p.removeAllowed =
                    (perm & acl.CUSTOMER_ADMIN_GRANT) !== 0 &&
                        !disabled.customerCategoryGroup.remove;
                break;
            }
            p.editAllowed = p.removeAllowed = (perm & acl.CUSTOMER_ADMIN_GRANT) !== 0;
            break;
        case 'CustomerUserGroup':
            if (disabled) {
                if (rowType === 'USER' && disabled.customerUserGroupUsers) {
                    p.editAllowed = true;
                    break;
                }
                else if (rowType === 'GROUP' && disabled.customerUserGroup) {
                    break;
                }
            }
            p.editAllowed = p.removeAllowed = (perm & acl.CUSTOMER_ADMIN_GRANT) !== 0;
            break;
        case 'SuperAdminUserGroup':
        case 'CustomerAdminUserGroup':
        case 'CustomerVisibilityUserGroup':
            if (rowType === 'USER') {
                p.editAllowed = true;
                p.removeAllowed = (perm & acl.SUPER_ADMIN_GRANT) !== 0;
            }
            break;
        case 'ProjectAdminUserGroup':
            if (rowType === 'USER') {
                p.editAllowed = true;
                p.removeAllowed = (perm & acl.PROJECT_ADMIN_GRANT) !== 0;
            }
            break;
        case 'LightAdminUserGroup':
            p.editAllowed = p.removeAllowed = (perm & acl.PROJECT_ADMIN_GRANT) !== 0;
            break;
        case 'CategoryUserGroup':
        case 'NormalUserGroup':
            p.editAllowed = p.removeAllowed = (perm & acl.LIGHT_ADMIN_GRANT) !== 0;
            break;
        case 'SokoBidAdminUserGroup':
        case 'SokoBidCategoryUserGroup':
            if (rowType === 'USER') {
                p.editAllowed = true;
                p.removeAllowed = (perm & acl.SOKOBID_ADMIN_GRANT) !== 0;
            }
            break;
        case 'SokoBidUserGroup':
            p.editAllowed = p.removeAllowed = (perm & acl.SOKOBID_ADMIN_GRANT) !== 0;
            break;
        case 'WorksiteDiaryUserGroup':
        case 'TRMVRUserGroup':
            p.editAllowed = p.removeAllowed = (perm & acl.CUSTOMER_ADMIN_GRANT) !== 0;
            break;
        case 'UserProfileWorksiteDiaryMaster':
        case 'UserProfileWorksiteDiarySupervisor':
        case 'UserProfileWorksiteDiaryUser':
        case 'UserProfileTRMVREmployer':
        case 'UserProfileTRMVREmployee':
        case 'UserProfileTRMVRPreview':
            if (rowType === 'USER') {
                p.editAllowed = true;
                p.removeAllowed = (perm & acl.PROJECT_ADMIN_GRANT) !== 0;
            }
            break;
    }
    return p;
};
exports.getPerm = getPerm;
